import { http } from "../http";
import { Params, FaultClosed } from "@/facilities/model/user";
import { TABLEPAI } from "@/enums/pageEnum";

export const getDetailInfo = async (url: string) => {
  return await http.get(`/api/${url}`);
};

export const getTableHeaderConfig = async (type?: string) => {
  return await http.get(TABLEPAI.USER_PROPERTS, {
    params: { type },
  });
};

export const updateTableHeaderConfig = async (params: {
  type?: string;
  body: string[] | React.Key[];
}) => {
  return await http.put(TABLEPAI.USER_PROPERTS, params);
};

export const updateReportSort = async (params: {
  type: string;
  body: {
    groupBy?: string | null;
    sortField?: string | null;
    sort?: string | null;
  };
}) => {
  return await http.put(TABLEPAI.USER_PROPERTS, params);
};

export const exportLift = async (url?: string, params?: Params) => {
  return await http.get(`/api/${url}/export`, {
    params,
  });
};

export const getSelectLists = async (url: string, params?: Params) => {
  return await http.get(url, { params });
};

export const setAcknowledge = async (id?: string) => {
  return await http.put(`/api/lift/fault/ack/${id}`);
};

export const liftClosed = async (params?: FaultClosed) => {
  return await http.put("/api/lift/fault/report", params);
};

export const liftTrapClosed = async (params?: FaultClosed) => {
  return await http.put("/api/passenger/trap/report", params);
};

export const getLiftFaultCount = async (url: string, params?: any) => {
  return await http.get(url, { params });
};

export const setTrapAcknowledge = async (params?: Params) => {
  return await http.put("/api/passenger/trap/ack", params);
};
